import { CardContent, Stack, Typography } from '@mui/material'
import { FragmentType, graphql, useFragment } from '@/generated/gql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DietaryRow from '@/components/DietaryListMui'
import useTenant from '@/hooks/useTenant'

const canteenMenuItemIngredientsVendorDataFragment = graphql(`
  fragment CanteenMenuItemIngredients_VendorDataFragment on Vendor {
    id
    companyName
  }
`)

const canteenMenuItemIngredientsItemDataFragment = graphql(`
  fragment CanteenMenuItemIngredients_ItemDataFragment on MenuItem {
    _id
    name
    isCombo
    ingredients
    dietaries
    allergens
    subAllergens {
      cereals
      nuts
    }
  }
`)

type Props = {
  itemData: FragmentType<typeof canteenMenuItemIngredientsItemDataFragment>
  vendorData: FragmentType<typeof canteenMenuItemIngredientsVendorDataFragment>
}

const MenuItemIngredients: React.FC<Props> = ({
  itemData: itemDataProp,
  vendorData: vendorDataProp,
}) => {
  const tenant = useTenant()
  const { ingredients, dietaries, allergens, subAllergens, isCombo } = useFragment(
    canteenMenuItemIngredientsItemDataFragment,
    itemDataProp,
  )
  const { companyName } = useFragment(canteenMenuItemIngredientsVendorDataFragment, vendorDataProp)
  const { t } = useTranslation()
  return (
    <CardContent>
      <Stack spacing={3} direction="column">
        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle3">{t('cc:ingredientList')}</Typography>
          <Typography color="text.secondary" variant="body2">
            ({t('cc:allInformationProvidedBy')} {companyName})
          </Typography>
        </Stack>
        <Typography variant="body1" color="text.secondary">
          {ingredients}
        </Typography>
        <Typography variant="subtitle3">{t('cc:dietaryFlags')}</Typography>
        <DietaryRow showLabel allergens={[]} dietaries={dietaries} />
        <Typography variant="subtitle3">{t('cc:allergens')}</Typography>
        <DietaryRow
          isComboItem={Boolean(isCombo)}
          showLabel
          allergens={allergens}
          subAllergens={subAllergens}
          dietaries={[]}
        />
        {tenant.id !== '66ab5c5872a12355ff1f968a' ? (
          <Typography color="text.secondary" variant="body2">
            {t('allergens:info')}
          </Typography>
        ) : null}
      </Stack>
    </CardContent>
  )
}

export default MenuItemIngredients
